export default "__VITE_ASSET__DNONyGt1__"